class CurrencyConverter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="currency-wrapper relative">
        <div id="currency-switch">
          <div class="drop group/currency-drop">
            <div class="selected"></div>
            <div
              class="
                list
                hidden
                shadow-md
                shadow-white/50
                bg-[var(--base-heading-text)]
                text-[var(--base-accent)]
                group-[.show]/currency-drop:flex
                flex-wrap
                gap-y-4
                -mt-0.5
                py-2.5
                pl-5
                absolute
                right-1
                top-full
                w-52
                z-999
              "
            ></div>
          </div>
        </div>
      </div>
    `;
  }

  setupEventListeners() {
    const currency_switch_drop = this.querySelector('#currency-switch .drop');

    const link_classes = [
      'pl-9',
      'py-2',
      'relative',
      'block',
      'cursor-pointer',
      'text-inherit',
      'leading-none',
      'w-1/2',
      'before:bg-no-repeat',
      'before:bg-cover',
      'before:bg-center',
      'before:rounded-full',
      'before:absolute',
      'before:h-6',
      'before:w-6',
      'before:left-0',
      'before:top-1/2',
      'before:-translate-y-1/2',
    ];

    if (currency_switch_drop) {
      Object.keys(window.EXCHANGE.currencies).forEach((cur) => {
        const list_item = document.createElement('button');

        list_item.dataset.cur = cur;
        list_item.innerHTML = cur;
        list_item.setAttribute('aria-label', cur);
        list_item.setAttribute('class', link_classes.join(' '));
        currency_switch_drop.querySelector('.list').append(list_item);
      });

      currency_switch_drop.querySelector('.selected').innerHTML =
        '<button id="selected-currency" class="' +
        link_classes.join(' ') +
        '" data-cur="' +
        window.EXCHANGE.current_currency +
        '">' +
        window.EXCHANGE.current_currency +
        '</button>';
    }
  }
}

customElements.define('currency-converter', CurrencyConverter);
